import request from "@/utils/request";

export function getPermissionReshte() {
  return request({
    url: "permission/getreshte",
    method: "post",
  });
}

export function getEmtiazDetails(formSerial) {
  return request({
    url: "permission/emtiazdetails",
    method: "post",
    data: { FormSerial: formSerial },
  });
}

export function getPermissionHistory() {
  return request({
    url: 'permission/gethistory',
    method: 'post'
  })
}

export function saveRequest(file, reshte, ostan, comment) {
  let fileName = file == null ? "" : file.name;
  var fmData = new FormData();

  fmData.append("Reshte", reshte);
  fmData.append("Ostan", ostan);
  fmData.append("Comment", comment);
  fmData.append("image", file);
  fmData.append("fileName", fileName);

  return request({
    url: "permission/save",
    method: "post",
    data: fmData,
  });
}

export function removePermissionRequest(requestID) {
  return request({
    url: 'permission/remove',
    method: 'post',
    data: { requestID: requestID }
  })
}

export function downloadAttach(requestID, token) {
  return request({
    url: "/permission/downloadattach",
    method: "post",

    data: { RequestID: requestID, HashToken: token },
  });
}
